import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "../../icon";
import { Link } from "../../link";
import { useTheme } from "styled-components";
import { DisabledLink, StyledHomeLinkItem, StyledLinkItem, } from "./linkttem.styles";
export const LinkItem = ({ index, data: { text, url, windowTarget = "_self", onClick }, isLast, previewId, }) => {
    const theme = useTheme();
    const isFirst = index === 0;
    const LinkItemWrapper = isFirst ? StyledHomeLinkItem : StyledLinkItem;
    if (!url || isLast) {
        return (_jsxs(LinkItemWrapper, Object.assign({ hasText: !!text }, { children: [_jsx(Icon, { symbol: isFirst ? "Home" : "ChevronFlatRight", color: theme.colors.grey10, width: "1.5rem" }), text && _jsx(DisabledLink, { children: text })] })));
    }
    return (_jsxs(LinkItemWrapper, Object.assign({ "data-preview-id": previewId, hasText: !!text }, { children: [!isFirst && (_jsx(Icon, { symbol: "ChevronFlatRight", color: theme.colors.grey10 })), _jsx(Link, { windowTarget: windowTarget, stylingType: "flat", icon: isFirst && "Home", target: url, href: url, text: text, onClick: onClick })] })));
};
